import type { DynamicText } from '../dynamic/types';

export type FieldMappingConfig = {
  mode: FormConfigMode;
};

export type RemoteTemplate = {
  id: string;
  name: string;
};

export type FormInput = {
  checksum: string;
  label: DynamicText[];
  fieldMappings: FieldMapping[];
  inputs?: FormInput[];
};

export type FormConfig = {
  id: number;
  mode: FormConfigMode;
  remoteId: string | null;
  remoteName: string | null;
  inputsCount?: number;
  inputs?: FormInput[];
  errors?: string[];
};

export type FormConfigCreateParams = Pick<FormConfig, 'remoteId' | 'remoteName'>;

export type FormConfigInputs = {
  inputsCount: number;
  inputs: FormInput[];
};

export enum FormConfigMode {
  STATIC = 'static',
  DYNAMIC = 'dynamic',
}

export type FieldMapping = {
  id: number;
  inputChecksum: string;
  source: FieldMappingSource;
  sourceId: string;
  data: {
    id: number;
    name: string;
    templateName: string;
    metadata: Record<string, any>;
  };
};

export type FieldMappingCreateParams = {
  inputChecksum: string;
  sources: Array<{
    source: FieldMappingSource;
    sourceId: string;
    sourceContext: Record<string, any>;
  }>;
};

export type UpdateFieldMappingsPositionsParams = {
  orderedIds: number[];
  inputChecksum: string;
};

export type Source = {
  id: string;
  compoundId: string;
  type: FieldMappingSource;
  name: string;
  templateName: string;
  metadata: Record<string, any>;
};

export enum FieldMappingSource {
  CUSTOM_FIELD = 'custom_field',
  OPEN_QUESTION = 'open_question',
  QUESTIONNAIRE_QUESTION = 'questionnaire_question',
}
